export const LANGUAGES = [
    { label: 'EN', code: 'en' },
    { label: 'FR', code: 'fr' },
]
